<template>
  <div class="dashboard background">
    <toast />
    <dashboard-page pcontent="1" page="COURSES">
      <!-- course manager  -->
      <card w='80%' minWidth='950px' v-if='true'>
        <!-- card header -->
        <div class='fRow fullWidth jStart aCenter'>
          <div class='growFull fCol jStart aStart'>
            <h3 class='growFull text-right'>مدیریت ویدئوها و فایل‌های «{{course.title}}»</h3>
            <p class='note'>اضافه و حذف ویدئوها و فایل‌های «{{course.title}}»</p>
          </div>
          <btn isMini='true' label='بازگشت به دوره‌ها' bc='#667089'
            style="margin: 8px !important;"
            icon='keyboard_arrow_left' @click.native="backToCourse"/>
        </div>
        <div class="courseInfoHolder fRow jStart aCenter fullWidth">
          <img :src="`${this.baseURL}/${course.photo}`"
            :alt="course.title" class="c">
          <div class="fCol jCenter aStart infos growFull">
            <div class="courseName">{{course.title}}</div>
            <div class="courseId"
            :title="`در صورت نیاز این کد را برای مسئول فنی ${appName.faName} ارسال کنید`"
            >کد سیستمیِ دوره: {{this.cId}}</div>
            <div class="courseSummary">{{course.summary}}</div>
            <div class="fRow jStart aCenter fullWidth teacherHolder">
              <img :src="`${this.baseURL}/${course.teacherAvatar}`" alt="" class="t">
              <div class="fCol growFull jStart aStart">
                <!-- eslint-disable-next-line -->
                <div class="courseTeacher">مدرس: {{course.teacherFullName}}</div>
                <div class="courseLesson">مربوط به درس {{course.lesson.title}}</div>
              </div>
            </div>
          </div>
          <div class="counter fRow jCenter aCenter wrap">
            <i class="material-icons-round">duo</i>
            <label>{{this.cVideoCount}}</label>
            <span class="fullWidth">ویدئوهای این دوره</span>
          </div>
        </div>
        <div class="tabHeader fRow jCenter aCenter fullWidth" id="tab">
          <a @click="toggleUploader('upload')"
            class="tabBtn fRow jCenter aCenter
            w33 transition-fast" v-bind:class="{selected: uploaderShow}">
            <i class="material-icons-round transition-fast">backup</i>
            <span class="transition-fast">آپلود ویدئوی جدید</span>
          </a>
          <a @click="toggleUploader('list')"
            class="tabBtn fRow jCenter aCenter
            w33 transition-fast" v-bind:class="{selected: !uploaderShow &&!filesShow}">
            <i class="material-icons-round transition-fast">movie_creation</i>
            <span class="transition-fast">نمایش ویدئوهای دوره</span>
          </a>
          <a @click="toggleUploader('file')"
            class="tabBtn fRow jCenter aCenter
            w33 transition-fast" v-bind:class="{selected: filesShow}">
            <i class="material-icons-round transition-fast">attachment</i>
            <span class="transition-fast">مدیریت فایل‌های دوره</span>
          </a>
        </div>
        <!-- آپلودر ها اینجا نشون داده میشن -->
        <div class="uploadersHolder fCol jStart aCenter fullWidth"
          v-if='uploaderShow' id="uploaders">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>قوانین و مقررات آپلود فایل</h3>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>حجم ویدئو</h4>
              <p>حجم فایل باید زیر 1 گیگابایت باشد.</p>
              <p>برای بهبود سرعت آپلود حتماً فیلترشکن خود را قطع کنید.</p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>ابعاد ویدئو</h4>
              <p>ویدئوها باید دارای نسبت طول به ارتفاع 16:9 باشد.</p>
              <p class="ltr">برای مثال 1080 × 1920  یا  720 × 1280</p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>فرمت‌های مجاز</h4>
              <p>فرمت‌های مجاز برای ویدئو .MP4 و .webM می‌باشند.</p>
            </div>
            <div class="ruleBox fCol jStart aStart w25">
              <h4>تعداد ویدئو</h4>
              <p>شما می‌توانید با توجه به سرعت اینترنت،
                به تعداد دلخواه ویدئو به صورت همزمان آپلود کنید.</p>
            </div>
          </div>
          <uploader v-for="(item, index) in uploaderArray" v-bind:key="item.id"
            :id='`uploader${index}`' :uploaderId='index'
            :course='cName' :courseId='course.id'
            @fileSelected='addNewUploader'/>
        </div>
        <!-- نمایش ویدئوهای دوره -->
        <div class="videoList fRow jBetween aStart fullWidth wrap ltr"
          id='list' v-if="!uploaderShow && !filesShow">
          <div class="rules fullWidth fRow jStart aStart wrap">
            <h3>لیست ویدئو‌های «{{course.title}}»</h3>
            <div class="ruleBox fCol jStart aStart w20">
              <h4>فیلتر لیست</h4>
              <p>لیست ویدئو را فیلتر کنید</p>
            </div>
            <div class="ruleBox fCol jStart aStart w40">
              <h4>بر اساس عنوان</h4>
              <input type="text" placeholder="عنوان ویدئوی مورد نظر">
            </div>
            <div class="ruleBox fCol jStart aStart w20">
              <h4>شماره قسمت</h4>
              <input type="number" placeholder="قسمت">
            </div>
            <div class="ruleBox fCol jStart aStart w20">
              <h4>وضعیت</h4>
            </div>
          </div>
          <div class="w33 fCol jStart aCenter">
            <video-item />
          </div>
          <div class="w33 fCol jStart aCenter">
            <video-item />
          </div>
          <div class="w33 fCol jStart aCenter">
            <video-item />
          </div>
          <div class="w33 fCol jStart aCenter">
            <video-item />
          </div>
        </div>
        <!-- مدیریت فایلها  -->
        <div class="uploadersHolder fullWidth fRow jBetween aStart" v-if="filesShow">
          <div class="w60 fCol jStart aStart">
            <file-uploader
              @activeUploaders="activeFileUploaders = true"
              @refreshFiles="getCourseFiles"
              @uploaded="getUploadedFiles"
              :course="course"
              :courseId="course.id" />
          </div>
          <div class="w40 fCol jStart aStart list">
            <h3 class="fRow jStart aCenter secondary">
              <i class="material-icons-round">attachment</i>
              فایل‌های ثبت شده برای این دوره</h3>
            <div class="fCol jCenter aCenter fullWidth"
              v-if="!loaded">
              <p-bar
                :loading="loading"
                :notYet="notYet"
                :noContent="noContent"
                :notFound="notFound"
                :error="error" />
            </div>
            <ul class="growFull fullWidth" v-if="loaded">
              <li class="fullWidth fRow jStart aCenter"
                v-for="(item, index) in courseFiles" v-bind:key="index">
                <div class="rad">{{index + 1}}</div>
                <span class="growFull">{{item.name}}</span>
                <i class="material-icons-round delete"
                  @click="deleteCourseFile(course.id, item.id)">delete</i>
              </li>
            </ul>
          </div>
        </div>
        <empty-bar v-if="false" w='100%' h='152px' msg='هیچ دوره‌ای ثبت نشده'/>
        <error-bar v-if="false" w='100%' h='152px' :msg='errorMsg'/>
        <progress-bar v-if="false" w='100%' h='160px' msg='لطفا صبر کنید'/>
      </card>
    </dashboard-page>
    <tool-bar/>
    <right-menu/>
    <modal v-if="modalShow">
      <card w="580px">
        <label class="question">با ترک این صفحه آپلودها متوقف می‌شوند.
          آیا مایل به ترک این صفحه هستید؟</label>
        <div class="fullWidth wrap aStart jStart fRow btnRow">
          <btn label="نمایش لیست ویدئوها" btnWidth='236px' bc='#ff0533'
          icon="delete_sweep" @click.native="showListAnyWay"/>
          <keep-alive>
            <btn fabBtn='true' label="بازگشت" btnWidth='auto'
              @click.native="closeModal" bc='#aaaaaa' icon="close"/>
          </keep-alive>
        </div>
      </card>
    </modal>
  </div>
</template>

<script>
import RightMenu from '@/components/RightMenu.vue';
import ToolBar from '@/components/ToolBar.vue';
import DashboardPage from '@/components/DashboardPage.vue';
import Card from '@/components/Card.vue';
import Btn from '@/components/Btn.vue';
import errorHandler from '@/mixins/mixin';
import makeToast from '@/mixins/makeToast';
import Toast from '@/components/Toast.vue';
import ticks from '@/mixins/ticks';
import ProgressBar from '@/components/ProgressBar.vue';
import ErrorBar from '@/components/ErrorBar.vue';
import EmptyBar from '@/components/EmptyBar.vue';
import Uploader from '@/components/Uploader.vue';
import VideoItem from '@/components/VideoItem.vue';
import Modal from '@/components/Modal.vue';
import FileUploader from '@/components/FileUploader.vue';
import axios from 'axios';
import pBar from '@/components/pBar.vue';

export default {
  mixins: [errorHandler, makeToast, ticks],
  data() {
    return {
      baseURL: this.$store.state.baseUrl,
      V: this.$store.state.apiVersion,
      teacherId: this.$store.state.courseObject.teacherId,
      cName: this.$store.state.courseObject.name,
      cId: this.$store.state.courseObject.id,
      cPhoto: this.$store.state.courseObject.photo,
      cTeacher: this.$store.state.courseObject.teacher,
      cLesson: this.$store.state.courseObject.lesson,
      cSummary: this.$store.state.courseObject.summary,
      cVideoCount: this.$store.state.courseObject.videos,
      teacherImg: '',
      uploaderCount: 1,
      uploaderArray: ['1'],
      uploaderShow: true,
      filesShow: false,
      isVideoUploading: false,
      modalShow: false,
      activeFileUploaders: false,
      uploadedFilesArray: [],
      courseFiles: [],
      // modes ↓
      loading: false,
      noContent: false,
      notFound: false,
      error: false,
      notYet: true,
      loaded: false,
      modeMsg: '',
      // modes ↑
      course: this.$store.state.courseObject,
    };
  },
  methods: {
    backToCourse() {
      this.$store.commit('resetCourseObject');
      this.$router.push('/courses');
    },
    getTeacherPhoto() {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Teachers/${this.teacherId}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        this.posts = response.data;
        if (this.posts.isSuccess) {
          // console.log(this.posts);
          this.teacherImg = this.posts.data.user.avatar;
        } else {
          this.responseFalse = true;
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      });
    },
    getCourseFiles() {
      this.setMode('loading');
      const reqUrl = `${this.baseURL}/api/v${this.V}/Courses/files/${this.course.id}`;
      axios({
        method: 'get',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.courseFiles = response.data.data;
          if (this.courseFiles.length === 0) {
            this.setMode('noContent');
          } else {
            this.setMode('loaded');
          }
        } else {
          this.setMode('error', 'مشکلی پیش آمده است');
        }
      }, (error) => {
        this.setMode('error', this.errorHandler(error));
      }).catch(() => {
        this.setMode('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید');
      });
    },
    deleteCourseFile(courseId, fileId) {
      const reqUrl = `${this.baseURL}/api/v${this.V}/Courses/file/${courseId}/${fileId}`;
      axios({
        method: 'delete',
        url: reqUrl,
        headers: {
          Authorization: this.$authObeject.authToken(),
        },
      }).then((response) => {
        if (response.data.isSuccess) {
          this.makeToast('success', 'فایل با موفقیت حذف شد', 3000);
          this.getCourseFiles();
        } else {
          this.makeToast('warning', 'خطا در حذف فایل', 3000);
        }
      }, (error) => {
        this.makeToast('error', this.errorHandler(error), 3000);
      }).catch(() => {
        this.makeToast('error', 'خطای ناشناخته، لطفا اتصال به اینترنت را بررسی کنید', 3000);
      });
    },
    addNewUploader() {
      // alert(event);
      this.isVideoUploading = true;
      this.uploaderCount += 1;
      this.uploaderArray.push(this.uploaderCount.toString());
    },
    closeModal() {
      this.modalShow = false;
    },
    showListAnyWay() {
      this.isVideoUploading = false;
      this.modalShow = false;
      this.toggleUploader('list');
    },
    toggleUploader(order) {
      this.uploaderShow = false;
      this.filesShow = false;
      switch (order) {
        case 'file': {
          this.filesShow = true;
          break;
        }
        case 'upload': {
          this.uploaderShow = true;
          break;
        }
        case 'list': {
          if (this.isVideoUploading) {
            // this.makeToast('warning', 'ویدئو ها چی؟', 2500);
            this.modalShow = true;
            return;
          }
          this.uploaderShow = false;
          this.uploaderArray = ['1'];
          this.uploaderCount = 1;
          break;
        }
        default:
          break;
      }
    },
    getUploadedFiles() {
      // console.log(this.uploadedArray);
    },
    setMode(m, msg) {
      this.noContent = false;
      this.loading = false;
      this.notYet = false;
      this.error = false;
      this.loaded = false;
      this.modeMsg = '';
      switch (m) {
        case 'loading': {
          this.loading = true;
          break;
        }
        case 'loaded': {
          this.loaded = true;
          break;
        }
        case 'error': {
          this.modeMsg = msg;
          this.error = true;
          break;
        }
        case 'notYet': {
          this.notYet = true;
          break;
        }
        case 'noContent': {
          this.noContent = true;
          break;
        }
        default:
          break;
      }
    },
  },
  components: {
    ProgressBar,
    ErrorBar,
    EmptyBar,
    RightMenu,
    ToolBar,
    DashboardPage,
    Card,
    Btn,
    Toast,
    Uploader,
    VideoItem,
    Modal,
    FileUploader,
    pBar,
  },
  computed: {
    appName() {
      return this.$store.state.appName;
    },
  },
  mounted() {
    this.$nextTick(() => {
      this.getCourseFiles();
      if (this.course.id === '' || this.course.id === undefined) {
        this.$router.push('/courses');
      }
      // this.getTeacherPhoto();
    });
  },
};
</script>

<style lang="scss" scoped>
  .counter{
    min-width: 96px;
  }
  .counter label{
    font-weight: bold;
    margin-right: 8px;
    font-size: 32px;
    color: rgba($color: #363636, $alpha: 1.0);
  }
  .counter span{
    font-weight: 100;
    font-size: 12px;
    color: rgba($color: #363636, $alpha: 1.0);
  }
  .courseInfoHolder {
    padding: 24px;
    margin-bottom: 24px;
    border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.2);
  }
  $iw: 204px;
  .courseInfoHolder img.c{
    width: $iw;
    height: $iw;
    border-radius: 8px;
  }
  .infos{
    padding: 0 24px;
  }
  .courseInfoHolder .courseName{
    font-size: 28px;
    word-spacing: -2px;
    font-weight: 400;
    color: #61187A;
    text-align: right;
    line-height: 1.3;
    border-right: solid 4px rgba($color: #61187A, $alpha: 1);
    padding: 0px 8px 0 0;
  }
  .courseInfoHolder .courseTeacher{
    font-size: 16px;
    word-spacing: -2px;
    font-weight: 400;
  }
  .courseInfoHolder .courseLesson{
    font-size: 13px;
    word-spacing: 0px;
    font-weight: 400;
  }
  .courseId{
    padding: 2px 8px;
    font-size: 10px;
    margin-bottom: 16px;
    letter-spacing: 2px;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }
  .courseSummary{
    padding: 8px 8px 16px;
    font-size: 12px;
    text-align: right;
    color: #646464;
    border-right: solid 4px rgba($color: #000000, $alpha: 0.2);
  }

  .teacherHolder img.t{
    width: 64px;
    height: 64px;
    margin-left: 8px;
    border-radius: 80px 0 80px 80px;
  }

  .question{
    font-size: 18px;
    font-weight: 300;
    margin-bottom: 16px;
    text-align: right;
  }

  .ltr {
    direction: ltr !important;
  }

  .rules{
    margin: 24px 24px 50px;
  }

  .ruleBox {
    padding: 0 8px;
  }

  .uploadersHolder h3, .videoList h3 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 20px;
    font-weight: 400;
  }

  .uploadersHolder h4, .videoList h4 {
    width: 100%;
    text-align: right;
    padding: 8px 16px;
    word-spacing: -2px;
    font-size: 14px;
    font-weight: 200;
    position: relative;
  }

  .uploadersHolder h4::before, .videoList h4::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: royalblue;
    left: calc(100% - 8px);
    top: 50%;
    transform: translateY(-50%);
  }

  .uploadersHolder p, .videoList p {
    width: 100%;
    text-align: right;
    padding: 0px 16px;
    word-spacing: -1px;
    font-size: 12px;
    font-weight: 200;
    margin: 0 0 4px 0;
    position: relative;
  }

  .uploadersHolder p::before, .videoList p::before{
    position: absolute;
    content: ' ';
    border-radius: 50%;
    width: 8px;
    height: 8px;
    background-color: rgba(65, 105, 225, 0.301);
    left: calc(100% - 8px);
    top: 5px;
  }

  input[type="text"], input[type='number'] {
    border-radius: 4px;
    border: solid 1px rgba($color: #000000, $alpha: 0.2);
    padding: 4px 8px;
    font-size: 13px;
    font-weight: 200;
    width: 100%;
  }
  // new
  .list {
    border-radius: 8px;
    overflow: hidden;
    height: 450px;
    box-shadow: 0 8px 16px 0 rgba($color: #000000, $alpha: 0.15);
    h3 {
      font-size: 12px;
      font-weight: 300;
      text-align: right;
      color: white;
      padding: 8px;
      margin: 0;
      border-bottom: solid 1px rgba($color: #000000, $alpha: 0.15);
      i {
        font-size: 16px;
        margin-left: 8px;
        color: rgba($color: white, $alpha: 0.70);
      }
    }
    ul {
      padding: 0;
      margin: 0;
      overflow: hidden auto;
      li {
        list-style: none;
        padding: 8px;
        border-bottom: dashed 1px rgba($color: #000000, $alpha: 0.15);
        .rad {
          font-size: 10px;
          text-align: right;
          width: 24px;
        }
        span {
          font-size: 12px;
          font-weight: 200;
          color: #131313;
          text-align: right;
        }
        i.delete {
          font-size: 16px;
          padding: 4px;
          border-radius: 50%;
          margin-right: 8px;
          cursor: pointer;
          color: white;
          background-color: rgba($color: #b43838, $alpha: 0.8);
        }
      }
      li:hover {
        background-color: rgba($color: #000000, $alpha: 0.01);
      }
    }
  }
</style>
